import {
  GroupByMode,
  ID,
  overdueSectionID,
  ReorderSectionUpdate,
  SortingMode,
  UserSettings,
} from '@griply/types';

export type BuildUpcomingReorderUserSettingsOptions = {
  updatedSections: ReorderSectionUpdate[];
  // Mobile passes true: the touched legacy `todoSorting` keys are nulled so the
  // converter treats the new store as authoritative. Web dual-writes the order.
  clearLegacy?: boolean;
};

export const buildUpcomingReorderUserSettings = ({
  updatedSections,
  clearLegacy,
}: BuildUpcomingReorderUserSettingsOptions): Partial<UserSettings> | null => {
  const newOrder = updatedSections.reduce<Record<ID, ID[]>>((acc, section) => {
    if (section.id === overdueSectionID) {
      return acc;
    }
    acc[section.id] = section.taskSorting;
    return acc;
  }, {});

  if (!Object.keys(newOrder).length) {
    return null;
  }

  // Values are `null` at runtime (Firestore clears the bucket); typed as ID[] to fit
  // the legacy `todoSorting` shape.
  const legacyTodoSorting = clearLegacy
    ? Object.keys(newOrder).reduce<Record<string, ID[]>>((acc, key) => {
        acc[key] = null as unknown as ID[];
        return acc;
      }, {})
    : newOrder;

  return {
    customTaskOrder: {
      upcoming: { [GroupByMode.UpcomingDeadline]: newOrder },
    },
    todoSortingMode: SortingMode.Custom,
    todoSorting: legacyTodoSorting,
  };
};
